var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconParkOutlineLocalPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 16.6667C21.7678 16.6667 23.4635 15.9643 24.7137 14.714C25.964 13.4638 26.6663 11.7681 26.6663 9.99999C26.6663 8.23188 25.964 6.53619 24.7137 5.28595C23.4635 4.03571 21.7678 3.33333 19.9997 3.33333C18.2316 3.33333 16.5359 4.03571 15.2856 5.28595C14.0354 6.53619 13.333 8.23188 13.333 9.99999C13.333 11.7681 14.0354 13.4638 15.2856 14.714C16.5359 15.9643 18.2316 16.6667 19.9997 16.6667Z",
    stroke: "#FC6430",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 16.6667V31.6667M13.333 26.6667H9.99967L3.33301 36.6667H36.6663L29.9997 26.6667H26.6663",
    stroke: "#FC6430",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParkOutlineLocalPin);
export default __webpack_public_path__ + "static/media/icon-park-outline_local-pin.1afca8e7ad4ba2c6cbe618472c2751c6.svg";
export { ForwardRef as ReactComponent };